import React, { useState } from "react";
import "./PortfolioCarousel.css";

// Import local images
import photo1 from "../assets/images/banner/1.jpg";
// import photo2 from "../assets/images/2.jpg";
// import photo3 from "../assets/images/3.jpg";
// import photo4 from "../assets/images/4.jpg";
// import photo5 from "../assets/images/5.jpg";
// import photo6 from "../assets/images/6.jpg";

const PortfolioCarousel = () => {
  // Array of images
  const images = [
    { src: photo1, alt: "Photo 1 description" },
    // { src: photo2, alt: "Photo 2 description" },
    // { src: photo3, alt: "Photo 3 description" },
    // { src: photo4, alt: "Photo 4 description" },
    // { src: photo5, alt: "Photo 5 description" },
    // { src: photo6, alt: "Photo 6 description" },
  ];

  // State to track current image
  const [currentIndex, setCurrentIndex] = useState(0);

  // // Handlers for navigation
  // const goToPrevious = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === 0 ? images.length - 1 : prevIndex - 1
  //   );
  // };

  // const goToNext = () => {
  //   setCurrentIndex((prevIndex) =>
  //     prevIndex === images.length - 1 ? 0 : prevIndex + 1
  //   );
  // };

  return (
    <div className="carousel">
      {/* <button className="carousel-button left" onClick={goToPrevious}>
        &lt;
      </button> */}
      <div className="carousel-image-container">
        <img
          src={images[currentIndex].src}
          alt={images[currentIndex].alt}
          className="carousel-image"
        />
      </div>
      {/* <button className="carousel-button right" onClick={goToNext}>
        &gt;
      </button> */}
    </div>
  );
};

export default PortfolioCarousel;
